import { capabilities } from 'navigation-components/capabilities';
import { CallIconStatus } from 'navigation-components/config';
import { useCapability } from 'navigation-components/platform/hooks';
import { useCallback, useEffect, useState } from 'react';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { CallIcon, CallIconStatus as UICallIconStatus } from '../../../nav-ui-components/Icons/CallIcon';
import { useTranslation } from '../../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallIconWithStatus = memoWithDisplayName('CallIconWithStatus', () => {
  const {
    t
  } = useTranslation();
  const [iconStatus, setIconStatus] = useState(CallIconStatus.OFFLINE);
  const [shouldShowActiveCallState, setShouldShowActiveCallState] = useState(false);
  const handleStatusChange = useCallback(({
    status,
    shouldShowActiveCallState: _shouldShowActiveCallState
  }) => {
    if (status !== undefined) setIconStatus(status);
    if (_shouldShowActiveCallState !== undefined) setShouldShowActiveCallState(_shouldShowActiveCallState);
  }, []);
  const {
    subscribe: subscribeToCallIconStatus
  } = useCapability(capabilities.UPDATE_CALL_ICON_STATUS_CAP.getName());
  useEffect(() => {
    subscribeToCallIconStatus(handleStatusChange);
  }, [handleStatusChange, subscribeToCallIconStatus]);
  const title = t('nav.calling.callIcon.title');
  switch (iconStatus) {
    // first party
    case CallIconStatus.ONLINE:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.ONLINE,
        shouldShowActiveCallState: shouldShowActiveCallState,
        statusSeleniumTestId: "call-remote-toggle-connected"
      });
    case CallIconStatus.ERROR:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.ERROR,
        statusSeleniumTestId: "call-remote-toggle-connection-error"
      });

    // third party
    case CallIconStatus.EMPTY_CIRCLE:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.EMPTY_CIRCLE,
        statusSeleniumTestId: "empty-circle"
      });
    case CallIconStatus.GREEN_FILLED_CIRCLE:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.ONLINE,
        statusSeleniumTestId: "green-filled-circle"
      });
    case CallIconStatus.GREEN_FILLED_CIRCLE_PULSING:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.ONLINE,
        shouldShowActiveCallState: true,
        statusSeleniumTestId: "green-filled-circle"
      });
    case CallIconStatus.SOLID_CROSS:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title,
        status: UICallIconStatus.SOLID_CROSS
      });
    case CallIconStatus.BASE_PHONE:
    default:
      return /*#__PURE__*/_jsx(CallIcon, {
        title: title
      });
  }
});